import React from 'react';

//Calling React's Context API in order to use one Firebase instance
//at the top-level of the component hierarchy in App component.
const LocationContext = React.createContext(null);


export default LocationContext;
